<template>
  <div id="main-content">
    <SuccessBanner :header="successHeader()">
      <div v-html="successText()"></div>
    </SuccessBanner>
    <QuickLinks :linksData="relatedArticles" v-if="!isBuildCRM()" />
  </div>
</template>

<script>
import { SuccessBanner, QuickLinks } from '@/components';
import { isBuildCRM } from '@/utils';
import { GENERATE_MEMBER_CARD_REQUEST, GENERATE_MEMBER_CARD_REQUEST_SUCCESS } from '@/router/routeNames';

const isCRM = isBuildCRM();
const h2Regex = /<h2>(.*?)<\/h2>/;

export default {
  name: 'SuccessRequestNewCards',

  components: {
    SuccessBanner,
    QuickLinks,
  },

  data() {
    return {};
  },

  computed: {
    /**
     * Get the related articles from the route params.
     * this.$route.params.content[0] contains the info text
     * & this.$route.params.content[1] contains the array of related articles.
     */
    relatedArticles() {
      if (this.$route?.params?.content[1]) {
        return this.$route.params.content[1];
      }
      return [];
    },
  },

  mounted() {
    // Only add the listener if not running in CRM mode.
    // Add a listener for the back browser button.
    if (!isCRM) {
      window.addEventListener('popstate', this.handleBack, false);
    }
  },

  beforeUnmount() {
    // Only remove the listener if not running in CRM mode.
    if (!isCRM) {
      // Remove the listener for the back browser buttons.
      window.removeEventListener('popstate', this.handleBack);
    }
  },

  methods: {
    /**
     * If the user hits the back window button on the success page take them back to the order page.
     */
    handleBack() {
      if (this.$route.name !== GENERATE_MEMBER_CARD_REQUEST_SUCCESS) {
        this.$router.push({ name: GENERATE_MEMBER_CARD_REQUEST, query: { step: 1 } });
      }
    },

    successHeader() {
      if (isCRM) return 'Thanks, your member card request was successful';

      // Extract the text between the <h2> tags
      const h2Match = this.$route.params?.content[0]?.match(h2Regex);
      return h2Match ? h2Match[1] : '';
    },

    successText() {
      if (isCRM) {
        return `<p>Your cards will be sent to your nominated postal address. You should receive them in the next 10 business days.</p><p>Keep your card with you for instant recognition and convenient on-the-spot claims at most extras providers. You’ll also need to present your card if you or someone covered by your policy goes to hospital. So keep it safe.</p>`;
      }

      return this.$route.params?.content[0]?.replace(h2Regex, '');
    },

    isBuildCRM,
  },
};
</script>

<style lang="scss" scoped>
#quick-links {
  margin-bottom: 2rem;

  @include mobile {
    margin-bottom: 1rem;
  }
}
</style>
